
// -----------------------------
// swiper系
// -----------------------------

(function () {
  //swiper
  let indexKvSlider = new Swiper(".js-index-kv-slide", {
    speed: 2000,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
    },

    pagination: {
      el: ".kv-pagination",
      clickable: true
    },
    // navigation: {
    //   nextEl: ".swipe-common-btn-next",
    //   prevEl: ".swipe-common-btn-prev",
    // },
    // breakpoints: {
    //   601: {
    //     loop: false,
    //     slidesPerView: 3,
    //   },
    // },
  });


  const sliderThumbnailsArg = function(perView) {
    const obj = {
      slidesPerView: 3.5,
      centeredSlides: true,
      loop: true,
      breakpoints: {
        601: {
          slidesPerView: perView,
          centeredSlides: false,
        },
      },
    }
    return obj;
  }

  const sliderHasThumbnailsArg = function(targetElm) {
    const obj = {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-about-button-next",
        prevEl: ".swiper-about-button-prev",
      },
      thumbs: {
        swiper: targetElm,
      },
    }
    return obj;
  }

  // サムネイル
  let sliderThumbnails1 = new Swiper(".js-index-about-slide-thumbs1", sliderThumbnailsArg(7));
  // スライダー
  let sliderHasThumbnails1 = new Swiper(".js-index-about-slide1", sliderHasThumbnailsArg(sliderThumbnails1));

  // サムネイル
  let sliderThumbnails2 = new Swiper(".js-index-about-slide-thumbs2", sliderThumbnailsArg(4.5));
  // スライダー
  let sliderHasThumbnails2 = new Swiper(".js-index-about-slide2", sliderHasThumbnailsArg(sliderThumbnails2));

  // SPのみswiper起動させる
  function sliderActivateOnSp(slider) {
    const sliderElm = slider.$el[0];
    const ww = window.innerWidth;
    const slides = sliderElm.querySelectorAll('.js-swiper-slide-judge');
    if(ww > 600) {
      slides.forEach((e)=>{
        if(e.classList.contains('swiper-slide')) {
          e.classList.remove('swiper-slide');
          e.classList.add('swiper-slide-nonactive');
          e.style.width = '';
        }
      });
    } else {
      slides.forEach((e)=>{
        if(e.classList.contains('swiper-slide-nonactive')) {
          e.classList.remove('swiper-slide-nonactive');
          e.classList.add('swiper-slide');
        }
      });
    }
  }

  const spSwiper = new Swiper(".js-sp-news-slide", {
    speed: 200,
    loop: false,
    slidesPerView: 1,
    pagination: {
      el: ".sp-slide-pagination",
      clickable: true
    },
    on: {
      beforeInit: function () {
        sliderActivateOnSp(this);
      },
      resize: function () {
        sliderActivateOnSp(this);
      },
    },
  });

  let gallerySlider = new Swiper(".js-gallery-slide", {
    speed: 1000,
    loop: true,
    slidesPerView: 3,
    centerMode: true,
    effect: "coverflow",
    coverflowEffect: {
      depth: 10,
      modifier:	1,
      rotate:	40,
      scale: 0.8,
      slideShadows:	true,
      stretch: 0,
    },
    autoplay: {
      delay: 2000,
    },

    pagination: {
      el: ".gallery-pagination",
      clickable: true
    },
    // navigation: {
    //   nextEl: ".swipe-common-btn-next",
    //   prevEl: ".swipe-common-btn-prev",
    // },
    // breakpoints: {
    //   601: {
    //     loop: false,
    //     slidesPerView: 3,
    //   },
    // },
  });


})();
